import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
} from "@angular/core";
import { RoutingStatesService } from "src/app/core/services/routingStates.service";
import { RoutingStates } from "src/app/core/models/routingStates";
import { Router } from "@angular/router";
import { SharedInfoService } from "src/app/core/services/sharedInfo.service";
import { Options } from "../filters/models/filters.model";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { FiltersTableJSON } from "src/app/core/models/filter-table-state.model";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { TranslateService } from "@ngx-translate/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableComponent implements OnInit {
  @Input() tableList: any[];
  @Input() elementList;
  @Input() routing;
  @Input() numPages: number;
  @Input() numElements: number;
  @Input() totalElements: number;
  @Input() mastertable: string;
  @Input() filterParams: FiltersTableJSON;
  @Input() options: Options;
  @Input() showFilterButtons: boolean;

  @Output() valueFilterTable = new EventEmitter<any>();
  @Output() elementsToRemove = new EventEmitter<any[]>();
  @Output() moveUpDown = new EventEmitter<any>();
  @Output() downloadFile = new EventEmitter<any>();
  @Output() headerButtonsActionEvent = new EventEmitter<string>();
  @Output() downloadReportEvent = new EventEmitter<string>();
  @Output() valuePreviousCerts = new EventEmitter<string>();

  @ViewChild("deleteSwal")
  public readonly deleteSwal!: SwalComponent;

  checkedElementList = [];
  checkedElementListData = [];
  checkedAll: boolean = false;
  esMovil: boolean = false;

  constructor(
    private router: Router,
    private routingStatesService: RoutingStatesService,
    private sharedService: SharedInfoService,
    private filtersTableStateService: FiltersTableStateService,
    private toastrAlertService: ToastrAlertService,
    private translateService: TranslateService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.sharedService.message$.subscribe((message) => {
      if (message === "search") this.headerButtonsAction("search");
    });
    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .subscribe(result => {
        this.esMovil = result.matches;
      });
  }

  ngOnInit(): void {
    if (this.options && !this.options.style) {
      this.options.style = { "min-width": "1100px" };
    }
    if (this.mastertable != undefined) {
      switch (this.mastertable) {
        case "AyudasGenerales":
          this.filterParams["order"] = "AY_TITULO";
          break;
        case "MotivosRechazo":
        case "MotivosReedicion":
          this.filterParams["order"] = "MR_ID";
          break;
        default:
          this.filterParams["order"] = this.routing.id;
      }
    }
  }

  public onChangeOrder(order: string, asc: boolean): void {
    this.filterParams["asc"] = asc;
    this.filterParams["order"] = order;
    this.createStringParameters();
  }

  setPage(page) {
    this.filterParams["page"] = page;

    this.createStringParameters();
  }

  createStringParameters() {
    let filterTable;

    if (this.mastertable != undefined && this.filterParams["order"] == "id") {
      filterTable =
        "asc=" +
        this.filterParams["asc"] +
        "&page=" +
        this.filterParams["page"] +
        "&size=" +
        this.filterParams["size"];
    } else {
      filterTable =
        "asc=" +
        this.filterParams["asc"] +
        "&order=" +
        this.filterParams["order"] +
        "&page=" +
        this.filterParams["page"] +
        "&size=" +
        this.filterParams["size"];
    }
    this.valueFilterTable.emit({
      filterTableString: filterTable,
      filterTableJSON: this.filterParams,
    });
  }

  selectElement(id) {
    if (id !== "all") {
      let pos = this.checkedElementList.indexOf(id);
      if (pos == -1) {
        this.checkedElementList.push(id);
        pos = this.elementList.findIndex((e) => e[this.routing.id] === id);
        this.elementList[pos]["checked"] = true;
        this.checkedElementListData.push(this.elementList[pos]);
      } else {
        this.checkedElementList.splice(pos, 1);
        this.elementList[pos]["checked"] = false;
        this.checkedElementListData.splice(pos, 1);
      }
    } else {
      if (this.checkedAll) {
        this.checkedAll = false;
        this.checkedElementList = [];
        this.checkedElementListData = [];
        this.elementList.forEach((element) => {
          element["checked"] = false;
        });
      } else {
        this.checkedAll = true;
        this.checkedElementList = [];
        this.checkedElementListData = [];
        this.elementList.forEach((element) => {
          element["checked"] = true;
          this.checkedElementList.push(element[this.routing.id]);
          this.checkedElementListData.push(element);
        });
      }
    }
  }

  isChecked(id: string): boolean {
    const exist = (element) => element == id;
    let pos: number = this.checkedElementList.findIndex(exist);
    if (pos > -1) {
      return true;
    } else {
      return false;
    }
  }

  remove() {
    if (this.checkedElementList.length > 0) {
      this.deleteSwal.fire().then((result) => {
        if (result.isConfirmed) {
          this.elementsToRemove.emit(this.checkedElementList);
          this.checkedElementList = [];
          this.checkedElementListData = [];
        }
      });
    } else {
      let text: string = this.translateService.instant(
        "messages.noOneElementSelected"
      );
      this.toastrAlertService.toastrFail(text);
    }
  }

  setNavigationStates(id: string) {
    let arraySplited = this.router.url.split("/");
    let url: string = "";
    for (let i = 1; i < arraySplited.length - 1; i++) {
      url = url + "/" + arraySplited[i];
    }
    let idBefore = arraySplited[arraySplited.length - 1];
    let routingStates = new RoutingStates(
      this.routing.edit,
      id,
      url,
      decodeURIComponent(idBefore)
    );
    this.routingStatesService.setRoutingStates(routingStates);
  }

  goToEdit(id) {
    id = typeof id === "object" ? JSON.stringify(id) : id;
    if (this.mastertable) {
      this.router.navigate([this.routing.edit, this.mastertable, id]);
    } else {
      this.setNavigationStates(id);
      this.router.navigate([this.routing.edit, id]);
    }
  }

  goToCreate() {
    if (this.mastertable) {
      this.router.navigate([this.routing.create, this.mastertable]);
    } else {
      this.router.navigate([this.routing.create]);
    }
  }

  moveUp(id) {
    this.moveUpDown.emit({ move: "UP", id: id });
  }

  moveDown(id) {
    this.moveUpDown.emit({ move: "DOWN", id: id });
  }

  download(elemento: any) {
    this.downloadFile.emit(elemento);
  }

  headerButtonsAction(item: string) {
    this.headerButtonsActionEvent.emit(item);
  }

  downloadReport() {
    this.downloadReportEvent.emit("Descargar reporte");
  }

  getHistoryPreviousList(id: string) {
    this.valuePreviousCerts.emit(id);
  }
}
